// extracted by mini-css-extract-plugin
export default {"p":"info_p__3vck8","company":"info_company__XphqX","company__name":"info_company__name__vT2zj","spinner":"info_spinner__iJHMS"};